import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

class ContactInfoSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            contactInfo: null,
            loading: true,
            error: null,
        };
    }

    componentDidMount() {
        fetch(`${process.env.REACT_APP_API_URL}/api/globals/contact-info`)
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`HTTP error ${res.status}`);
                }
                return res.json();
            })
            .then((data) => {
                this.setState({
                    contactInfo: data,
                    loading: false,
                    error: null,
                });
            })
            .catch((error) => {
                console.error('Contact info fetch error:', error);
                this.setState({
                    contactInfo: null,
                    loading: false,
                    error: error.message || 'Failed to load contact info.',
                });
            });
    }

    render() {
        const { contactInfo, loading, error } = this.state;

        if (loading) {
            return (
                <Container className="my-5">
                    <p className="text-center">Loading contact information...</p>
                </Container>
            );
        }

        if (error) {
            return (
                <Container className="my-5">
                    <p className="text-center text-danger">Error: {error}</p>
                </Container>
            );
        }

        if (!contactInfo) {
            return (
                <Container className="my-5">
                    <p className="text-center">No contact information found.</p>
                </Container>
            );
        }

        const { title, description, email, phone, address } = contactInfo;

        return (
            <Container className="my-5">
                <Row className="justify-content-center">
                    <Col lg={8} md={10} xs={12}>
                        <div>
                            {title && <h1>{title}</h1>}
                            <div className="bg-primary mt-4 mb-4" style={{ height: '1px' }} />

                            {description && (
                                <p className='mb-5'>
                                    {description}
                                </p>
                            )}
                        </div>

                        <div>
                            {email && (
                                <div style={{ marginBottom: '1.5rem' }}>
                                    <h5 className='text-primary' style={{ marginBottom: '0.5rem' }}>Email</h5>
                                    <a
                                        href={`mailto:${email}`}
                                    >
                                        {email}
                                    </a>
                                </div>
                            )}

                            {phone && (
                                <div style={{ marginBottom: '1.5rem' }}>
                                    <h5 className='text-primary' style={{ marginBottom: '0.5rem' }}>Phone</h5>
                                    <a
                                        href={`tel:${phone}`}
                                    >
                                        {phone}
                                    </a>
                                </div>
                            )}

                            {address && (
                                <div>
                                    <h5 className='text-primary' style={{ marginBottom: '0.5rem' }}>Address</h5>
                                    <p
                                        style={{
                                            margin: 0,
                                            lineHeight: '1.6',
                                            whiteSpace: 'pre-line',
                                        }}
                                    >
                                        {address}
                                    </p>
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default ContactInfoSection;